import { gql } from "@apollo/client";

export const UPDATE_VENUE = gql`
  mutation updateVenue($updateVenueInput: UpdateVenueInput!) {
    updateVenue(updateVenueInput: $updateVenueInput) {
      id
    }
  }
`;
